"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableLine = void 0;
const drawable_1 = require("./drawable");
const label_drawable_1 = require("./label.drawable");
const line_point_drawable_1 = require("./line.point.drawable");
/**
 * Line is a "Width Marker" which also has a Label, a start point, and an end point.
 */
class CollectionModelDrawableLine extends drawable_1.CollectionModelDrawable {
    static createWithLinePointsAndLabel(drawableState, id, startPoint, endPoint, labelPoint, text, links) {
        const label = new label_drawable_1.CollectionModelDrawableLabel(drawableState, `${id}:label`, labelPoint.x, labelPoint.y, id, text, links);
        const start = new line_point_drawable_1.CollectionModelDrawableLinePoint(drawableState, `${id}:start`, startPoint.x, startPoint.y, id);
        const end = new line_point_drawable_1.CollectionModelDrawableLinePoint(drawableState, `${id}:end`, endPoint.x, endPoint.y, id);
        const line = new CollectionModelDrawableLine(drawableState, id, label.id, start.id, end.id);
        return { line, start, end, label };
    }
    constructor(collectionModelDrawableState, drawableId, labelId, startId, endId) {
        super(collectionModelDrawableState, drawableId);
        this._labelId = labelId;
        this._startId = startId;
        this._endId = endId;
    }
    static isLine(t) {
        return t instanceof CollectionModelDrawableLine;
    }
    get x() {
        return this.start.x;
    }
    get y() {
        return this.start.y;
    }
    get start() {
        return this.drawableState.getDrawable(this._startId);
    }
    get end() {
        return this.drawableState.getDrawable(this._endId);
    }
    get label() {
        return this.drawableState.getDrawable(this._labelId);
    }
    getLabelConnectionPoint(_options) {
        const startPoint = this.start;
        const endPoint = this.end;
        const midX = (startPoint.x + endPoint.x) / 2;
        const midY = (startPoint.y + endPoint.y) / 2;
        return { x: midX, y: midY };
    }
    get value() {
        return this.drawableState.collection.state
            .getGeometry(this.captureId)
            .calculateDistance(this.start.getVector(), this.end.getVector());
    }
    remove() {
        super.remove();
        // Remove this line's label too, unless it has already been removed
        if (this.drawableState.hasDrawable(this._labelId)) {
            this.label.remove();
        }
    }
    get isInsightMeasurement() {
        return false;
    }
    isApprovableInsightDrawable() {
        return false;
    }
    get isVisible() {
        return true;
    }
    clone(newParentDrawableState) {
        if (!newParentDrawableState.hasDrawable(this._labelId)) {
            this.label.clone(newParentDrawableState);
        }
        return new CollectionModelDrawableLine(newParentDrawableState, this.id, this._labelId, this._startId, this._endId);
    }
    equals(other) {
        return (other instanceof CollectionModelDrawableLine
            && this._startId === other._startId
            && this._endId === other._endId
            && this._labelId === other._labelId
            && this._equals(other));
    }
}
exports.CollectionModelDrawableLine = CollectionModelDrawableLine;
//# sourceMappingURL=line.drawable.js.map